import React from 'react';
import './WithWorkshop.scss';
import { safeHtml } from '../../../../services/helpers';

export default function WithWorkshop({ content }) {
    return (
        <div className="workshop-with_workshop" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
    )
}